import { Breadcrumb } from '@repo/ui/components/ui/breadcrumb';
import { Card } from '@repo/ui/components/ui/card';
import { UserDetail } from '@repo/ui/features/user/user-detail';
import { PageHeader } from '@repo/ui/ui/layout/page-header';
import { useNavigate, useParams } from 'react-router-dom';

export default function UtilisateurDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const goToList = () => navigate('/admin/droits/utilisateur');

  if (!id) {
    return <div className="p-4 text-destructive">ID utilisateur manquant</div>;
  }

  return (
    <div className="space-y-4">
      <div className="mb-2">
        <Breadcrumb
          items={[
            { label: 'Gestion' },
            { label: 'Utilisateurs', href: '/admin/droits/utilisateur' },
            { label: "Détail de l'utilisateur", current: true },
          ]}
          showHomeIcon
          onHomeClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        />
      </div>

      <PageHeader>
        <PageHeader.Title>Détail de l'Utilisateur</PageHeader.Title>
      </PageHeader>

      <Card className="p-4">
        <UserDetail
          userId={parseInt(id, 10)}
          onBack={goToList}
          onEdit={() => navigate(`/admin/droits/utilisateur/${id}/edit`)}
        />
      </Card>
    </div>
  );
}
